import { h } from 'preact'
import { HintStep } from '../../types'
import { HintContentListView } from '../HintContentListView'

export const HintStepView = (props: { stepKey?: string; step?: HintStep }) => {
  const { step, stepKey } = props

  if (step === undefined || stepKey === undefined) {
    return <div className="hint_step"></div>
  }

  return (
    <div className="hint_step">
      <HintContentListView contents={step.contents} idPrefix={stepKey} />
    </div>
  )
}
